import { actions } from "../../actions/action-list";
import initialState from "./initialState";

const OperationType = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.FETCH_OPERATION_TYPE:
      return { ...state, operationType: action.value };
    case actions.SELECTED_OPERATION_TYPE:
      return { ...state, selectedOperationType: action.value };
    default:
      return state;
  }
};
export default OperationType;
